import { page_builder_origin } from "features/PageBuilders/PageBuilders.constants";
import { appendUrlParams } from "utils/urlUtils";

export const GJS_PAGE_BUILDER_ROUTE_KEYS = {
  update: "gjs-sales-page-builder-update",
};

export const GJS_PAGE_BUILDER_ROUTE_IDS = {
  [GJS_PAGE_BUILDER_ROUTE_KEYS.update]:
    "/gjs-sales-page-builder/:salePageUuid/update",
};

export const query_params = {
  template_uuid: "template",
};

export const GJS_PAGE_BUILDER_ROUTE_GENERATORS = {
  [GJS_PAGE_BUILDER_ROUTE_KEYS.update]: ({ salePageUuid, templateUuid }) => {
    const params = {};
    if (templateUuid) {
      // Only add if templateUuid exists and is not null/undefined
      params[query_params.template_uuid] = templateUuid;
    }
    return appendUrlParams(
      `/gjs-sales-page-builder/${salePageUuid}/update`,
      params
    );
  },
};

/**
 * actions that the caqn be triggered from the page builder
 */
export const page_builder_action_keys = {
  listener_added: "listener-added",
  start_init: "start-init",
  save: "save",
  save_draft: "save-draft",
  auto_save: "auto-save",
  publish: "publish",
  upload_images: "upload-images",
  image_uploaded: "image-uploaded",
  media_library: {
    fetch_all: "media-library-fetch-all", // Fetch all data from media library
    fetched: "media-library-fetched", // Posts fetched media library data back to Page Builder
    get_preview_url: "get-preview-url", // Use to Fetch preview URL
    on_get_preview_url: "on-get-preview-url", // Posts Fetched Preview URL Data
  },
  notify: "notify",
  exit_builder: "exit-builder", // sent by the builder's back button - CT navigates away
  get_ai_access_token: "get-ai-access-token",
  ai_access_token: "ai-access-token",
  offering_card_select_open: "offering-card-select-open", // GJS page builder asks CT to open the offering picker modal
  offering_card_select_save: "offering-card-select-save", // CT posts the picked offering back to the page builder
  rating_setting_get: "rating-setting-get", // GJS page builder asks CT to read the account-level show_listing_ratings setting
  rating_setting_value: "rating-setting-value", // CT posts the setting value back to the page builder
  rating_setting_update: "rating-setting-update", // GJS page builder asks CT to persist the account-level show_listing_ratings setting
  rating_setting_updated: "rating-setting-updated", // CT confirms the setting write back to the page builder
  offering_timer_select_open: "offering-timer-select-open", // GJS page builder asks CT to open the slot-based offering picker for the timer block
  offering_timer_select_save: "offering-timer-select-save", // CT posts the picked slot-based offering back to the page builder
};

export const page_builder_url = `${page_builder_origin}/sale`;

/**
 * Payload keys shared between the GJS page builder (iframe) and the creator tool.
 * Used in start_init payload and processGJSPayloadNUpdate.
 */
export const page_builder_payload_keys = {
  theme: "theme",
  customPixelToken: "customPixelToken",
  customGaToken: "customGaToken",
};
